module.exports = __webpack_public_path__ + "static/media/matnrrd_3-1090w.eae49536.png";